import React, { useState, useEffect } from "react";
import Dropzone from "react-dropzone";
import { useRecoilValue, useRecoilState } from "recoil";
import { tokenAtom, userAtom } from "../../global/globalState";
import Axios from "axios";
import Aws from "aws-sdk";

const Assignments = () => {
    const [name, setName] = useState("");
    const [files, setFiles] = useState(null);
    const [user, setUser] = useRecoilState(userAtom);
    const [assignments, setAssignments] = useState([]);
    const [progress, setProgress] = useState("");
    const token = useRecoilValue(tokenAtom);

    useEffect(() => {
        Axios.get(`${process.env.REACT_APP_API_URL}/student/getAssignments`, {
            headers: {
                Authorization: "Bearer " + token,
            },
        })
            .then((res) => {
                console.log(res.data.response);
                setAssignments(res.data.response);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        if (progress === 100) {
            console.log("in");
            Axios.post(
                `${process.env.REACT_APP_API_URL}/teacher/upload`,
                {
                    assignmentGiven:
                        "https://aqua-assignment.s3-ap-southeast-1.amazonaws.com/assignments/" +
                        files[0].name,
                    description: name,
                },
                {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            )
                .then((res) => {
                    console.log(res.data);
                    setUser(res.data.response);
                    localStorage.setItem(
                        "user",
                        JSON.stringify(res.data.response)
                    );
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [progress]);

    Aws.config.update({
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    });

    const bucket = new Aws.S3({
        params: {
            Bucket: "aqua-assignment",
        },
        region: "ap-southeast-1",
    });

    const uploadFile = () => {
        const params = {
            ACL: "public-read",
            Key: "assignments/" + files[0].name,
            ContentType: files[0].type,
            Body: files[0],
        };

        bucket
            .putObject(params)
            .on("httpUploadProgress", (evt) => {
                setProgress(100);
            })
            .send((err) => {
                if (err) {
                    console.log(err);
                }
            });
    };

    return (
        <div className="Assignments">
            <div className="assignments">
                <div className="assignments-title">ALL ASSIGNMENTS</div>
                <div className="assignment-cards">
                    {assignments &&
                        assignments.map(({ assignmentDetails }) => (
                            <div className="assignment-card">
                                <h3 className="assignment-heading">
                                    {assignmentDetails.description}
                                </h3>
                                <p>
                                    File :{" "}
                                    <a href={assignmentDetails.assignmentGiven}>
                                        {assignmentDetails.assignmentGiven.substring(
                                            68
                                        )}
                                    </a>
                                </p>
                            </div>
                        ))}
                </div>
            </div>
            <div className="create-assignment">
                <div className="create-assignment-title">CREATE ASSIGNMENT</div>
                <div className="create-assignment-form ">
                    <label htmlFor="name">Name of Assignment</label>
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <div className="dropzone-container">
                        <div className="dropzone-title">Upload Files</div>
                        <Dropzone
                            onDrop={(files) => {
                                setFiles(files);
                                console.log(files);
                            }}
                            accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        >
                            {({
                                getRootProps,
                                getInputProps,
                                isDragActive,
                                isDragAccept,
                                isDragReject,
                            }) => {
                                const additionalClass = isDragAccept
                                    ? "accept"
                                    : isDragReject
                                    ? "reject"
                                    : "";

                                return (
                                    <div
                                        {...getRootProps({
                                            className: `dropzone ${additionalClass}`,
                                        })}
                                    >
                                        <input {...getInputProps()} />
                                        <span>
                                            {isDragActive ? "📂" : "📁"}
                                        </span>
                                        <p>
                                            Drag'n'drop images, or click to
                                            select files
                                        </p>
                                    </div>
                                );
                            }}
                        </Dropzone>
                        {files && (
                            <div className="selected-file">
                                Selected File : {files[files.length - 1].name}
                            </div>
                        )}
                    </div>

                    <button
                        className="primary submit"
                        onClick={() => uploadFile()}
                    >
                        CREATE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Assignments;
